import * as preact from "preact";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { $$requestManager } from "../../Core/RequestManager";
import { TextBox } from "../../Common/TextBox/TextBox";

interface IState
{
    errorMessage?: string;
}

export class Login extends BaseComponent<IBaseComponentProps, IState>
{
    private _txtEmail: TextBox;
    private _txtPassword: TextBox;

    private _onSubmitClick(): void
    {
        let auth: EveryWhen.Code.Model.UserAuthentication = { Username: this._txtEmail.getValue(), Password: this._txtPassword.getValue() };
        $$requestManager.execute("api/authentication/login", auth,
            () =>
            {
                let urlParams = new URLSearchParams(window.location.search);
                let returnUrl = urlParams.get('ReturnUrl');
                console.log(returnUrl);
                if (returnUrl)
                {
                    window.location.href = returnUrl;
                }
                else
                {
                    window.location.href = "/";
                }
            },
            (error) =>
            {
                this.setState({ errorMessage: error });
            });
    }

    render(props, state: IState)
    {
        return (
            <div style="padding: 30px 30px 10px 30px;border-radius: 3px; width: 300px; text-align: left; box-shadow:0px 0px 1px 10px #9ac3ec;background-color: white; margin: auto auto; margin-top: 200px;">
                <form onSubmit={(evt: preact.JSX.TargetedEvent<HTMLFormElement, Event>) =>
                {
                    evt.preventDefault();
                }}>



                    <table>
                        <tr>
                            <td>Email: </td>
                            <td><TextBox ref={(ref) => this._txtEmail = ref} /></td>
                        </tr>
                        <tr>
                            <td>Password: </td>
                            <td><TextBox ref={(ref) => this._txtPassword = ref} IsPassword={true} /></td>
                        </tr>
                    </table>
                    {
                        state.errorMessage
                            ? (
                                <div style="color:red;height: 20px;padding-left:70px">
                                    {state.errorMessage}
                                </div>
                            ) :
                            <div style="height: 20px;">
                            </div>
                    }

                    <div style="text-align:right;margin-right:43px;margin-top:10px;">
                        <button onClick={this._onSubmitClick.bind(this)}>Login</button>
                    </div>
                    <a href="NewUser" style="font-size:12px;">Create Account</a>
                </form>
            </div>
        );
    }
}